import type { AccountContext } from '@/types'

/**
 * Enterprise white-label builds (app/<client>/) bake the account payload into
 * the bundle at build time via VITE_BUNDLED_ACCOUNT (a JSON string, injected by
 * the client project's build script from its account.json). When present, the
 * native shell uses it as THE account — name, theme, gates, date config — so
 * account resolution needs no network at all: the app boots fully branded
 * before any request, and stays branded offline.
 *
 * Absent (the FlowRent-branded app/ shell and the in-LINE deployment), this
 * returns null and resolution works as before: /api/liff/resolve in LINE,
 * GET /api/customer/account in the generic native shell.
 */
export function getBundledAccount(): AccountContext | null {
  const raw = import.meta.env.VITE_BUNDLED_ACCOUNT
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as AccountContext
    // A payload without the two load-bearing fields is a broken build config;
    // refuse it rather than boot half-branded and mask the mistake.
    if (typeof parsed.id !== 'number' || typeof parsed.name !== 'string') return null
    return parsed
  } catch {
    return null
  }
}
